(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.shell:mxCommandPalette
	 * @module mx.shell
	 * @restrict 'E'
	 * @scope {}
	 * @requires $window
	 * @requires $timeout
	 * @requires $mdDialog
	 * @requires {@ref mx.shell.SidePanelActionsService mx.shell.SidePanelActionsService}
	 * @requires {@ref mx.shell.EventService mx.shell.EventService}
	 * @requires {@ref mx.internationalization mx.internationalization}
	 * @requires {@ref mx.shell.KeyboardNavigationService mx.shell.KeyboardNavigationService}
	 * @requires {@ref mx.shell.ContextService mx.shell.ContextService}
	 * @requires {@ref mx.shell.ActionExecutorService mx.shell.ActionExecutorService}
	 * @requires {@ref mx.shell.NavigationService mx.shell.NavigationService}
	 * @requires {@ref mx.shell.RoutingService mx.shell.RoutingService}
	 * @requires {@ref mx.shell.AppsService mx.shell.AppsService}
	 * @description
	 * Command palette component
	 * @usage <mx-command-palette />
	 */

	angular.module('mx.shell').directive('mxCommandPalette', [
		'$window',
		'mx.shell.SidePanelActionsService',
		'mx.shell.EventService',
		'mx.internationalization',
		'mx.shell.KeyboardNavigationService',
		'$mdDialog',
		'mx.shell.ContextService',
		'mx.shell.ActionExecutorService',
		'mx.shell.NavigationService',
		'mx.shell.RoutingService',
		'mx.shell.AppsService',
		'$timeout',
		function mxCommandPaletteDirective(
			$window,
			sidePanelActionsService,
			eventService,
			internationalization,
			keyboardNavigationService,
			$mdDialog,
			contextService,
			actionExecutorService,
			navigationService,
			routingService,
			appsService,
			$timeout
		) {
			return {
				restrict: 'E',
				scope: {},
				link: link,
			};

			function link(scope) {
				var isPaletteOpen = false;
				var isAutocompleteActive = false;

				var appTitle = internationalization.get('shell.mx-command-palette.open');
				var actionTitle = internationalization.get('shell.mx-command-palette.action');
				var navTitle = internationalization.get('shell.mx-command-palette.navigate');
				var settingsTitle = internationalization.get('shell.mx-command-palette.settings');

				registerHotkeys(scope);

				function registerHotkeys(scope) {
					var callback = $.throttle(1000, function (ev) {
						scope.$evalAsync(function () {
							if (isPaletteOpen) {
								$mdDialog.hide();
								isPaletteOpen = false;
								return;
							}

							var childrenCollection;

							isPaletteOpen = true;

							$mdDialog.show({
								controller: dialogCtrl,
								controllerAs: 'vm',
								templateUrl: 'components/mx-command-palette/mx-command-palette.html',
								parent: angular.element(document.body),
								targetEvent: ev,
								clickOutsideToClose: true,
								openFrom: document.body,
								closeTo: document.body,
								onComplete: function (scope) {
									var input = $('.command-palette-dialog input');

									input.on('keydown', function (ev) {
										if (ev.key === 'Tab') {
											$timeout(function () {
												var selectedItem = scope.vm.selectedItem;

												if (!selectedItem) {
													return;
												}

												if (selectedItem.children && selectedItem.children.length) {
													isAutocompleteActive = true;

													var children = selectedItem.children.filter(function (item) {
														if (item.disabled) {
															return;
														}

														item.displayType = navTitle;
														item.itemType = 'navitem';
														item.mainTitle = selectedItem.title + ' > ';

														return item;
													});

													childrenCollection = children;

													scope.vm.items = children;
													scope.vm.searchText = '';
													input.focus();
												} else {
													isAutocompleteActive = false;
													executeItem(selectedItem);
													$mdDialog.hide();
												}
											}, 100);
										}

										if (ev.key === 'Enter') {
											isAutocompleteActive = false;

											$timeout(function () {
												executeItem(scope.vm.selectedItem);
												$mdDialog.hide();
											}, 100);
										}

										if (ev.key === 'Escape') {
											$mdDialog.hide();
										}
									});
								},
								onRemoving: function cleanUp() {
									var input = $('.command-palette-dialog input');

									input.off();

									isAutocompleteActive = false;
									isPaletteOpen = false;
									childrenCollection = null;
								},
							});

							function executeAction(action) {
								actionExecutorService.execute(action, contextService.selectedObjects).catch(mx.logCatch);
							}

							function executeItem(item) {
								if (!item.itemType) {
									return;
								}

								switch (item.itemType) {
									case 'settings':
										navigationService.openSettingHandler();
										break;
									case 'navitem':
										navigate(item);
										break;
									case 'application':
										item.onItemClick();
										break;
									case 'action':
										executeAction(item);
										break;
								}
							}

							function navigate(item) {
								navigationService.currentItem = item;
							}

							dialogCtrl.$inject = ['$scope', '$element'];

							function dialogCtrl($scope, $element) {
								$scope.vm.getPaletteItems = getPaletteItems;

								$element.find('.command-palette').on('keydown', blockHints);
								$element.find('md-autocomplete').on('keydown', onKeyPress);

								$scope.vm.onSearchTextChange = function (query) {
									$scope.vm.items = getPaletteItems(query);
								};

								$scope.vm.onSelectedItemChange = function (selectedItem) {
									if (!selectedItem.hasChildren) {
										executeItem(selectedItem);
										$mdDialog.hide();
									}
								};

								$scope.vm.items = getPaletteItems($scope.vm.searchText);

								function blockHints(ev) {
									var SPACE_KEY = 32;

									if (ev.which === SPACE_KEY) {
										ev.stopPropagation();
									}

									if (ev.altKey) {
										ev.stopPropagation();

										if (ev.key === 'p') {
											$scope.$evalAsync(function () {
												$('input:focus').blur();
												$mdDialog.hide();
											});
										}
									}
								}

								function onKeyPress(ev) {
									if (ev.key !== 'Enter') {
										return;
									}

									$scope.$evalAsync(function () {
										$mdDialog.hide();
										if ($scope.vm.selectedItem) {
											executeItem($scope.vm.selectedItem);
										}
									});
								}

								function getPaletteItems(query) {
									var items = [];

									query = query || '';

									if (isAutocompleteActive) {
										return filterItems(childrenCollection, query);
									}

									return addApplications().then(addActions).then(addNavigationItems).then(addSettings).then(filterItems.bind(null, items, query));

									function addApplications() {
										return getApplications().then(function (apps) {
											decorateItems(apps, appTitle, 'application');
											items.push.apply(items, apps);
										});
									}

									function addActions() {
										return getActions().then(function (actions) {
											decorateItems(actions, actionTitle, 'action');
											items.push.apply(items, actions);
										});
									}

									function addNavigationItems() {
										return getNavigationItems().then(function (navigationItems) {
											decorateItems(navigationItems, navTitle, 'navitem');

											navigationItems = navigationItems.filter(function (navItem) {
												return navItem.disabled ? undefined : navItem;
											});

											items.push.apply(items, navigationItems);
										});
									}

									function addSettings() {
										if (navigationService.openSettingHandler) {
											items.push({
												title: settingsTitle,
												icon: 'settings',
												itemType: 'settings',
											});
										}
									}

									function decorateItems(items, displayType, itemType) {
										items.forEach(function (item) {
											item.displayType = displayType;
											item.itemType = itemType;
										});
									}
								}

								function filterItems(items, query) {
									if (items.length) {
										return items.filter(filter);
									}

									return [];

									function filter(item) {
										return item.title.toLowerCase().indexOf(query.toLowerCase()) !== -1;
									}
								}

								function getNavigationItems() {
									return navigationService.get();
								}

								function getApplications() {
									return appsService.getCurrentApplication().then(function (currentApp) {
										return appsService.getApplications().filter(function (app) {
											return app !== currentApp;
										});
									});
								}

								function getActions() {
									return sidePanelActionsService.calculateCommonActions();
								}
							}
						});
					});

					keyboardNavigationService.registerKey({
						scope: scope,
						key: 'alt+p',
						description: internationalization.get('shell.mx-command-palette.description'),
						callback: callback,
					});
				}
			}
		},
	]);
})();
